import {getRoleEntity, DISCRIMINATOR_FACEBOOK} from '../helpers';
import {
  getDiscriminatorField,
} from '../helpers';

let initSubscription = (nga) => {
    let subscription = nga.entity('subscription');
    let defaultFilterField = nga.field('default_filter_id', 'reference').label('Default filter').targetEntity(nga.entity('filter'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}}).validation({required: true});

    let facebookPageField = nga.field('facebook_pages', 'reference_many').targetEntity(nga.entity('stream'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search, discriminator: DISCRIMINATOR_FACEBOOK}}}).validation({required: true});

    subscription.listView().title('Subscription list').fields([
      nga.field('id').isDetailLink(true),
      nga.field('name', 'string'),
      nga.field('logo_url').template('<img class="subscription-logo-url" ng-if="value" alt="logo" src="{{value}}" />'),
      nga.field('country', 'country'),
      nga.field('invite_code').template('<span>https://app.ezyinsights.com/login/invite/{{value}}</span>'),
      nga.field('disabled_at', 'bool_timestamp').label('Disabled'),
     ]).filters([
        nga.field('name__icontains').label('Name')
     ]).actions(['create', 'filter'])
       .listActions(['edit', `<ezy-manage-subscription size="xs" entity="::entity" entry="::entry" />`])

    subscription.creationView().title('Create subscription').fields([
      nga.field('name', 'string'),
      nga.field('logo_url'),
      nga.field('invite_code'),
      nga.field('country', 'country'),
      defaultFilterField,
      facebookPageField,
      nga.field('users', 'referenced_list').targetEntity(nga.entity('user_subscription')).targetReferenceField('subscription_id')
        .targetFields([nga.field('user_id'), nga.field('email')])
        .listActions(['edit']),
      nga.field('disabled_at', 'bool_timestamp').label('Disabled'),
      nga.field('timezone', 'timezone'),
      nga.field('filters', 'referenced_list').targetEntity(nga.entity('filter')).targetReferenceField('subscription_id')
        .targetFields([nga.field('id'), nga.field('filter_name')])
        .listActions([]).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}}),
      nga.field('roles', 'referenced_list').targetEntity(getRoleEntity(nga)).targetReferenceField('subscription_id')
        .targetFields([nga.field('id'), nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('email')), nga.field('role_type_str')])
        .listActions(['edit']),
    ])
    subscription.editionView().title('Edit subscription').fields(subscription.creationView().fields()).actions(['list']);;

    return subscription;
}

let initPerson = (nga) => {
    let createAction = '<ma-create-button ng-if="::entity.creationView().enabled" entry="::entry" entity="::entity" default-values="{user_id:entry.values.user_id}" size="xs"></ma-create-button>';
    let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}});
    let person = nga.entity('person').label('User');
    person.listView().title('User list').fields([
      nga.field('user_id').isDetailLink(true),
      nga.field('full_name', 'string'),
      nga.field('email', 'email'),
      subscriptionField
     ]).filters([
        nga.field('email__icontains').label('Email'),
        nga.field('full_name__icontains').label('Full Name')
     ]).actions(['filter']).sortField("id")
       .listActions(['edit', `<ezy-impersonate-button size="xs" entity="::entity" entry="::entry" />`])

    person.creationView().title('Create user').fields([
      nga.field('full_name', 'string'),
      nga.field('email', 'email'),
      nga.field('profiles', 'referenced_list').targetEntity(nga.entity('profile')).targetReferenceField('user_id')
        .targetFields([
          nga.field('id'),
          getDiscriminatorField(nga, 'social_type'),
          nga.field('eid'),
        ]),
      nga.field('roles', 'referenced_list').targetEntity(getRoleEntity(nga)).targetReferenceField('user_id')
        .targetFields([
          nga.field('id'),
          nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')),
          nga.field('role_type_str').label('Role Type'),])
        .listActions(['edit', createAction, 'delete']),
      subscriptionField
    ])
    person.editionView().title('Edit user').fields(person.creationView().fields());

    return person;
}

let initProfile = (nga) => {
    let userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person'))
        .targetField(nga.field('full_name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}});
    let profile = nga.entity('profile');
    profile.listView().title('Profile list').fields([
      nga.field('id').isDetailLink(true),
      nga.field('eid', 'string'),
      getDiscriminatorField(nga, 'social_type'),
      userField
    ]).filters([
        nga.field('email__icontains').label('Email'),
        nga.field('eid__icontains').label('EID'),
        nga.field('first_name__icontains').label('First Name'),
        nga.field('last_name__icontains').label('Last Name')
     ]).actions(['filter']).sortField("id")
       .listActions(['edit', `<ezy-impersonate-button size="xs" entity="::entity" entry="::entry" />`])

    profile.creationView().title('Create Profile').fields([
      nga.field('first_name', 'string'),
      nga.field('last_name', 'string'),
      nga.field('registered_at', 'string').editable(false),
      nga.field('eid', 'string'),
      nga.field('email', 'email'),
      getDiscriminatorField(nga, 'social_type'),
      userField,
    ])
    profile.editionView().title('Edit Profile').fields(profile.creationView().fields());

    return profile;
}

export {initPerson, initSubscription, initProfile};



// WEBPACK FOOTER //
// ./client/app/entities/common.js